import { useState, useEffect } from 'preact/hooks';
import PropTypes from 'prop-types';
import Icon from '../Global/Icon';
import Text from '../Global/Text';
import { getCoverageTitle } from '../../utilities/coverage/titleUtils';
import { updateAdditionalCoverageAction } from '../../actions/UserData';
import { stepShowHide } from '../../utilities/form/formUtils';
import { getCoveragePrice } from '../../utilities/combined-common';

// ToggleSwitch styles and input
const ToggleSwitch = ({ isToggled, onToggle }) => {
  return (
    <div
      className={`toggleSwitch_outer ${isToggled ? 'isToggled' : ''}`}
      onClick={onToggle}
      data-testid="toggle-switch-0"
    >
      <div className={`toggleSwitch_inner ${isToggled ? 'toggled' : ''}`}>
        {isToggled ? <Icon icon="toggleWhite" /> : <Icon icon="toggle" />}
      </div>
    </div>
  );
};

export const Accordion = ({
  content,
  price,
  additionalCoverage,
  updateTotalPrice,
  clickCount,
  index,
  activeSwitches,
  onExpand,
  initialValues,
  dispatch,
  userData,
  item,
  toggleIndex,
  indexNum,
  hasBeenExpanded,
  onClickIcon
}) => {

  const { coverageList } = initialValues || {};
  const [isActive, setIsActive] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const tprice = userData.totalPrice;

  // Toggle Accordion on basis of clickCount & index
  const toggleAccordionNext = () => {
    if (clickCount >= index) {
      setIsActive(index === clickCount);
      setIsExpanded(index === clickCount);
    } else {
      setIsActive(false);
      setIsExpanded(false);
    }
  };

  const toggleAccordion = () => {
    setIsActive(!isActive);
    setIsExpanded(!isExpanded);
    toggleIndex(index);
  };
  useEffect(() => {
    if (indexNum === index) {
      setIsActive(true);
      setIsExpanded(true);
    } else {
      setIsActive(false);
      setIsExpanded(false);
    }
  }, [indexNum]);

  const getPrice = (coverages) => {
    let aprice = 0;
    if(coverages.length === 1) {
      aprice = coverages[0].packagePrice;
    }
    else {
      coverages.map((cov) => {
        if (cov.type === "limit" &&
        parseInt(userData[cov.field]) >= cov.min &&
        parseInt(userData[cov.field]) <= cov.max) {
          aprice = cov.packagePrice
        }
      })
    }
    return aprice;
  }

  const toggleSwitch = (coverageIndex, types) => {
    // Determine the additionalCoverage key and value based on the content type
    const additionalCoverageKey = `additionalCoverage-${content}`;
    const toggleState = !activeSwitches.includes(coverageIndex);
    // Dispatch the action to update insurance selections
    const actionPayload = [extractPackageCodes(coverageIndex)];
    const currentState = userData[additionalCoverageKey] || [];
    const data = {};
    data[additionalCoverage[coverageIndex].name] = false;
    let updatedState;
    if (toggleState) {
      updatedState = [...currentState, ...actionPayload];
      data[additionalCoverage[coverageIndex].name] = true;
      dispatch(updateAdditionalCoverageAction({ totalPrice: tprice + getCoveragePrice(types.coveragePrice, userData)}));
    } else {
      updatedState = currentState.filter(val => val !== actionPayload[0]);
      dispatch(updateAdditionalCoverageAction({ totalPrice: tprice - getCoveragePrice(types.coveragePrice, userData) }));
    }
    const payload = { [additionalCoverageKey]: updatedState };
    dispatch(updateAdditionalCoverageAction({ ...payload, ...data }));
    updateTotalPrice(index, coverageIndex);
  };

  // extract package codes based on coverageIndex
  const extractPackageCodes = (coverageIndex) => {
    const packageCodes = additionalCoverage
      .map(cov => cov.package);
    return packageCodes[coverageIndex];
  };


  useEffect(() => {
    toggleAccordionNext();
  }, [clickCount, index]);
  useEffect(() => {
    if (isActive && onExpand) {
      onExpand(content);
    }
  }, [isActive]);

  const coverageTitle = (data) => {
    return getCoverageTitle({}, coverageList, {}, "", data, true);
  }
  const handleClickicon = (value) => {
    onClickIcon(value);
  };
  // Expanded view details along with toggle & label, icon details
  const renderExpandedView = () => {
    if (!isActive) return null;
    const expandViewMultipleTimes = additionalCoverage && additionalCoverage.map((types, Itemindex) => {
      if (types.showHide && stepShowHide(types.hidden, types.showHide, userData)) {
        return <div />;
      }
      return (
        <div key={types.name}>
          <div className="expandedView_main">
            {types.type === "switch" && (
              <div>
                <div className="expandedView_display">
                  <div className="coverageTitle_content">{!types.displayName ? coverageTitle(types.package) : types.displayName}</div>
                  <div className="contentView_icon" onClick={() => handleClickicon(types)}>
                    <Icon icon="info" />
                  </div>
                  {/* ToggleSwitch Implementation */}
                  <div className="activeSwitches_main">
                    <span>{activeSwitches && activeSwitches.includes(Itemindex)}</span>
                    <ToggleSwitch
                      isToggled={
                        activeSwitches && activeSwitches.includes(Itemindex)
                      }
                      onToggle={() => {
                        toggleSwitch(Itemindex, types);
                      }}
                      data-testid="toggle-switch-0"
                    />
                  </div>
                </div>
                <div className="itemView_price">+{Math.round(getCoveragePrice(types.coveragePrice, userData))}
                  <Text value="$[units.$[paymentFrequency]]" />
                </div>
              </div>
            )}
            {types.type === "text" && (
              <div className="expandedView_display">
                <div className="coverageTitle_content">{types.value}</div>
                <div className="contentView_icon" onClick={() => handleClickicon(types.value)}>
                  <Icon icon="info" />
                </div>
              </div>
            )}
          </div>
        </div>
      )
    });

    return <>{expandViewMultipleTimes}</>;
  };
  const iconName = isExpanded ? 'chevronDownRed' : 'chevronDown';
  const getAccordionClass = () => {
    const baseClass = 'toggleSwitch_accordion';
    if (hasBeenExpanded && !isExpanded) return `${baseClass} active`;
    if (isExpanded) return `${baseClass} expanded`;
    return baseClass;
  };

  const getContentClass = () => {
    const baseClass = 'content_style';
    if (hasBeenExpanded && !isExpanded) return `${baseClass} active`;
    if (isExpanded) return `${baseClass} expanded`;
    return baseClass;
  };

  const getPriceClass = () => {
    const baseClass = 'toggleSwitch_accordion_price';
    if (hasBeenExpanded && !isExpanded) return `${baseClass} active`;
    if (isExpanded) return `${baseClass} expanded`;
    return baseClass;
  };

  const getBorderClass = () => {
    const baseClass = 'toggleSwitch_accordion_border';
    if (hasBeenExpanded && !isExpanded) return `${baseClass} active`;
    if (isExpanded) return `${baseClass} expanded`;
    return baseClass;
  };
  return (
    <div>
      <div
        className={getAccordionClass()}
        onClick={toggleAccordion}
        data-testid="toggle-accordion"
      >
        <div className="toggleSwitch_accordion_icon">
          {hasBeenExpanded && !isExpanded ? (
            <div className="toggle_icon_check" data-testid="toggle-accordion">
              <Icon icon="check" style={{ margin: 'auto' }} />
            </div>
          ) : (
            <Icon icon={iconName} data-testid="chevron-icon" />
          )}
        </div>
        <div className={getContentClass()} data-testid="content">
          {item && item.label}
        </div>
        <div className={`price_style ${hasBeenExpanded && !isExpanded ? 'active' : ''}`} />
        <div className={getPriceClass()} data-testid="price">
          {Math.round(price)}
          <Text value="$[units.$[paymentFrequency]]" />
        </div>
        <div className={`expanded_icon_style ${hasBeenExpanded && !isExpanded ? 'active' : ''}`}>
          {item && <anchor-product-illustration name={item.icon} size={item.size} />}
        </div>
      </div>
      <div className={getBorderClass()}>
        {renderExpandedView()}
      </div>
    </div>
  );
};

Accordion.defaultProps = {
  initialValues: {}
}

Accordion.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
  additionalCoverage: PropTypes.array.isRequired,
  item: PropTypes.object.isRequired,
}